// Virtual filesystem - shared between AI sidebar and notebook
const FS_KEY = 'codelves_fs';

class VirtualFS {
  constructor() {
    this.listeners = new Set();
    this.files = this._load();
  }

  _load() {
    try {
      const saved = localStorage.getItem(FS_KEY);
      return saved ? JSON.parse(saved) : this._defaults();
    } catch {
      return this._defaults();
    }
  }

  _defaults() {
    return {
      'main.py': '# Welcome to Codelves\n# Start coding with Python in your browser\n\nprint("Hello from Codelves!")\n',
      'utils.py': '# Utility functions\n\ndef greet(name):\n    return f"Hello, {name}! Welcome to Codelves."\n',
      'notebook.py': '# Notebook-style execution\nimport sys\nprint(f"Python {sys.version}")\n',
    };
  }

  _save() {
    localStorage.setItem(FS_KEY, JSON.stringify(this.files));
    this.listeners.forEach(fn => fn(this.getFileList()));
  }

  getFileList() {
    return Object.keys(this.files).sort();
  }

  readFile(name) {
    return this.files[name] ?? null;
  }

  writeFile(name, content) {
    this.files[name] = content;
    this._save();
  }

  deleteFile(name) {
    delete this.files[name];
    this._save();
  }

  renameFile(oldName, newName) {
    if (this.files[oldName] !== undefined) {
      this.files[newName] = this.files[oldName];
      delete this.files[oldName];
      this._save();
    }
  }

  subscribe(fn) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }

  toContext() {
    return Object.entries(this.files)
      .map(([name, content]) => `--- ${name} ---\n${content}`)
      .join('\n\n');
  }
}

// Singleton
const vfs = new VirtualFS();
export default vfs;
